export default __webpack_public_path__ + "static/media/cu_bg-1024x782.da211539.png";